import React from 'react'
import FooterContent from './footer-content'

const StorboltFooter = () => {

    return (
        <FooterContent>
            <div className='flex flex-col md:flex-row justify-between text-default-600 text-center text-sm p-4 md:p-0'>
                <div>
                    COPYRIGHT &copy; {new Date().getFullYear()} Storbolt, All rights Reserved
                </div>
                <div>
                    Made by{" "}
                    <a
                        href="https://ocnyamali.com"
                        target="_blank"
                        className="text-primary font-semibold"
                        rel="noreferrer"
                    >
                        OC
                    </a>
                </div>
            </div>
        </FooterContent>

    )
}

export default StorboltFooter